<div (click)="cardClicked() ">
    <mat-expansion-panel #panel hideToggle="true" class="pack-card">
        <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
            <mat-panel-title>
                <div class="pack-header">
                    <div>
                        <div class="dark-grey"><b>{{ pack.name | uppercase}}</b></div>
                        <div class="card-subtitle mb-2 text-muted">SKU {{ pack.barcode }}</div>
                    </div>
                </div>
                <i class="material-icons toggle-view"
                    (click)="$event.stopPropagation();panelH._toggle();toggleState = !toggleState">
                    <mat-icon *ngIf="!toggleState" class="card-icon" svgIcon="expand-more"></mat-icon>
                    <mat-icon *ngIf="toggleState" class="card-icon" svgIcon="expand-less"></mat-icon>
                </i>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pack-divider"></div>
        <div *ngFor="let product of pack.materials" (click)="$event.stopPropagation()" class="pack-product">
            <mat-icon class="card-icon" svgIcon="medicine_2"></mat-icon>
            <div class="pack-product-detail">
                <div>
                    <h5 class="t2 dark-grey font-weight-bold">{{ product.name }} ({{ product.availableQuantity || 0}} | {{ product.unitOfMeasure }})</h5>
                    <h6 class="t1 italic text-muted">SKU {{ product.barcode }}</h6>
                </div>
                <div class="product-quantity t3 dark-grey">
                    <b>{{product.quantity}}</b>
                </div>
            </div>
        </div>
        <div *ngFor="let service of pack.services" (click)="$event.stopPropagation()" class="pack-product">
            <mat-icon class="card-icon" svgIcon="services"></mat-icon>
            <div class="pack-product-detail">
                <div>
                    <h5 class="t2 dark-grey font-weight-bold">{{ service.name }}</h5>
                    <h6 class="t1 italic text-muted">SERVICE {{ service.barcode }}</h6>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</div>